import { FilterContentContainer } from "../../styles";

import { GroupField } from "./GroupField";
import type { GroupViewProps } from "./types";

const DEFAULT_VALUE = {};

export const DynamicGroupFilterView = ({ filter, value = DEFAULT_VALUE, onFilterUpdate }: GroupViewProps) => {
    return (
        <FilterContentContainer>
            {filter.getFields().map((field) => (
                <GroupField
                    key={field.key}
                    group={filter}
                    field={field}
                    groupValue={value}
                    view={field.filterView}
                    onFilterUpdate={onFilterUpdate}
                />
            ))}
        </FilterContentContainer>
    );
};
